export const START_TO_TYPE = 'Начните вводить данные';
